import React from "react";
import './index.scss';

const ResetPasswordIllustrations: React.FC = () => (
  <div className="login-illustration">
    <div className="login-tagline">
      <p className="login-tagline-eyebrow">PASSWORD RESET</p>
      <h2 className="login-tagline-heading">
        Your account,<br />
        secured and<br />
        <span className="login-tagline-accent">restored.</span>
      </h2>
      <div className="login-tagline-rule" />
      <p className="login-tagline-desc">
        Choose a strong new password<br />
        to protect your workspace.
      </p>
    </div>
  </div>
);

export default ResetPasswordIllustrations;
